import React from 'react';

import { Card, Text } from '@components/common';
import { CheckmarkInCircleSVG, ParticipantsSVG } from '@components/svgs';

import { CardHeader } from './CardHeader';

interface Props {}

export const Participants: React.FC<Props> = () => {
  return (
    <Card>
      <CardHeader icon={<ParticipantsSVG />} title='Participants' />
      <div className='text-center'>
        <div className='flex justify-center'>
          <CheckmarkInCircleSVG className='mb-2 h-8 w-8 text-green-500' />
        </div>
        <Text h='400' bold mb='1'>
          Recruitment submitted.
        </Text>
        <Text h='400' color='gray-500'>
          We'll notify you when participants respond.
        </Text>
      </div>
    </Card>
  );
};
